import { initStore } from 'libs/store';

import RootStore from './RootStore';

const { useStores, StoreProvider, registerStore } = initStore(RootStore, {});

export {
    useStores,
    StoreProvider,
    registerStore
};